import { assign } from 'lodash-es'

export default async ({ app: { $api } }, locale) => {
  const [common, apiTranslations] = await Promise.all([
    import(/* webpackChunkName: `lang-[request]` */ `~/lang/${locale}.json`),
    loadFromApi($api, locale)
  ])

  const translations = {
    ...common,
    _api: apiTranslations._api
  }
  return translations
}

async function loadFromApi($api, locale) {
  try {
    const res = await $api.i18n.get(locale)
    // provide translations of error messages for multiple ref ids
    res.data._api.message = extractRefIds(res.data._api.message)
    res.data._api.detailedMessage = extractRefIds(res.data._api.detailedMessage)
    return { ...res.data }
  } catch (err) {
    return {}
  }
}

export function extractRefIds(translation = {}) {
  const extracedTranslations = {}
  // first only those with multiple refIds
  Object.keys(translation)
    .filter((key) => key.includes('|'))
    .forEach((key) => {
      assign(
        extracedTranslations,
        Object.fromEntries(
          key.split('|').map((refId) => [refId, translation[key]])
        )
      )
    })
  // those entries with a single ref id overwrite those with multiple ones
  Object.keys(translation)
    .filter((key) => !key.includes('|'))
    .forEach((key) => {
      if (extracedTranslations[key]) {
        extracedTranslations[key] = {
          ...extracedTranslations[key],
          ...translation[key]
        }
      } else {
        extracedTranslations[key] = translation[key]
      }
    })
  return extracedTranslations
}
